/* eslint-disable prefer-rest-params */
import pathOr from 'ramda/src/pathOr'

export default {
  methods: {
    getShopRateColor() {
      const rate = Number(pathOr(0, ['props', 'reviews_rate'], this.shop))
      if (0 === rate) return null
      if (2 >= rate) return '#FFDAD6'
      if (3 > rate) return '#FF8C00'
      if (4 > rate) return '#FCFFC1'
      if (5 >= rate) return '#BAF5B4'
      return null
    },
    getShopRateTextColor() {
      const rate = Number(pathOr(0, ['props', 'reviews_rate'], this.shop))
      if (0 === rate) return null
      if (2 >= rate) return '#FF3B30'
      if (3 > rate) return '#A65A00'
      if (4 > rate) return '#A67402'
      if (5 >= rate) return '#1BBD32'
      return null
    },
  },
}
